import React from 'react';
import { node, string } from 'prop-types';
import { transformCurrencies } from '../../../utils/currency';
import { localeSettings, user, rollouts } from '../../../PropTypes';
import { HEADER_SOURCE, PACKAGE_CLASSNAME } from '../../../constants';
import { DEFAULT_STYLE, LINK_CLASSNAME, LINK_TITLE_CLASSNAME } from '../constants';

const CurrencyLink = ({ style = DEFAULT_STYLE, Component }, { currency, supportedCurrencies, user, rollouts }) => {
    const props = {
        currency: currency?.code,
        user,
        style,
        className: LINK_CLASSNAME,
        titleClassName: LINK_TITLE_CLASSNAME,
        modalClassName: PACKAGE_CLASSNAME,
        supportedCurrencies: transformCurrencies(supportedCurrencies),
        source: HEADER_SOURCE,
        rollouts,
    };

    return <Component {...props} />;
};

CurrencyLink.propTypes = {
    style: string,
    Component: node.isRequired,
};

CurrencyLink.contextTypes = {
    currency: localeSettings.currency,
    supportedCurrencies: localeSettings.supportedCurrencies,
    user,
    rollouts,
};

export default CurrencyLink;
